import { Grid } from '@mui/material'
import {
  CustomInput,
  CustomSelect,
  CustomTextArea,
  selectTypes,
} from 'src/consumer/components/helperComponents'
import {
  GenericModalHeadlineLevelTwo,
  StyledEventInputContainer,
  StyledEventReactSelect,
  StyledEventTextArea,
} from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'
import {
  StyledClinicLocationContainer,
  StyledLocationFieldContainer,
  StyledRestLocationFieldsContainer,
} from 'src/mentor/components/MentorEventsPage/MentorEventsPageStyles'

export default function LocationConfiguration({
  basicEventObject,
  setBasicEventObject,
  handleChangeLocation,
  changeCountry,
  unSecureSetupData,
  isDisabled,
}) {
  if (basicEventObject?.meetingSrc !== 'offline') {
    return null
  }

  return (
    <div>
      <GenericModalHeadlineLevelTwo>Meeting Location</GenericModalHeadlineLevelTwo>
      {!!basicEventObject?.contextId ? (
        <StyledClinicLocationContainer>
          <StyledLocationFieldContainer>
            <strong>Address </strong>
            <span>{basicEventObject?.location?.address || 'Not set'}</span>
          </StyledLocationFieldContainer>
          <StyledRestLocationFieldsContainer>
            <StyledLocationFieldContainer>
              <strong>Country </strong>
              <span>
                {unSecureSetupData?.metaCountries?.find(
                  (country) => basicEventObject?.location?.countryCode === country.id,
                )?.name || 'Not set'}
              </span>
            </StyledLocationFieldContainer>
            <StyledLocationFieldContainer>
              <strong>City </strong>
              <span>{basicEventObject?.location?.city || 'Not set'}</span>
            </StyledLocationFieldContainer>
            <StyledLocationFieldContainer>
              <strong>State </strong>
              <span>{basicEventObject?.location?.state || 'Not set'}</span>
            </StyledLocationFieldContainer>
            <StyledLocationFieldContainer>
              <strong>Pincode </strong>
              <span>{basicEventObject?.location?.pincode || 'Not set'}</span>
            </StyledLocationFieldContainer>
            <StyledLocationFieldContainer>
              <strong>Latitude </strong>
              <span>{basicEventObject?.location?.lat || 'Not set'}</span>
            </StyledLocationFieldContainer>
            <StyledLocationFieldContainer>
              <strong>Longitude </strong>
              <span>{basicEventObject?.location?.lng || 'Not set'}</span>
            </StyledLocationFieldContainer>
          </StyledRestLocationFieldsContainer>
        </StyledClinicLocationContainer>
      ) : (
        <Grid container spacing={1}>
          <Grid item xs={12} md={12}>
            <CustomTextArea
              id="address"
              label={'Address'}
              minHeight={80}
              value={basicEventObject?.location?.address}
              onChange={handleChangeLocation}
              customTextAreaComponent={StyledEventTextArea}
              options={unSecureSetupData?.metaCountries}
              getOptionValue={(option) => option?.id}
              getOptionLabel={(option) => option.name}
              selectType={selectTypes.string}
              disabled={!!basicEventObject?.contextId || isDisabled}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomSelect
              id="countryCode"
              label={'Country'}
              value={basicEventObject?.location?.countryCode}
              onChange={changeCountry}
              options={unSecureSetupData?.metaCountries?.sort((a, b) =>
                a?.name?.localeCompare(b.name),
              )}
              customComponent={StyledEventReactSelect}
              getOptionValue={(option) => option?.id}
              getOptionLabel={(option) => option.name}
              selectType={selectTypes.string}
              isDisabled={!!basicEventObject?.contextId || isDisabled}
              menuPlacement="auto"
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomInput
              id="city"
              label={'City'}
              value={basicEventObject?.location?.city}
              inputAndMessageContainer={StyledEventInputContainer}
              placeholder="Enter your city..."
              onChange={handleChangeLocation}
              disabled={!!basicEventObject?.contextId || isDisabled}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomInput
              id="state"
              label={'State'}
              value={basicEventObject?.location?.state}
              inputAndMessageContainer={StyledEventInputContainer}
              placeholder="Enter your state..."
              onChange={handleChangeLocation}
              disabled={!!basicEventObject?.contextId || isDisabled}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomInput
              id="pincode"
              label={'Pincode'}
              value={basicEventObject?.location?.pincode || ''}
              inputAndMessageContainer={StyledEventInputContainer}
              placeholder="Enter your pincode..."
              type="number"
              onChange={(e) => {
                console.log(e.target.value)
                const inputValue = e.target.value.slice(0, 6)
                setBasicEventObject((prev) => ({
                  ...prev,
                  location: {
                    ...prev.location,
                    pincode: inputValue,
                  },
                }))
              }}
              disabled={!!basicEventObject?.contextId || isDisabled}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomInput
              id="lat"
              label={'Latitude'}
              value={basicEventObject?.location?.lat}
              inputAndMessageContainer={StyledEventInputContainer}
              placeholder="Enter latitude..."
              type="number"
              onChange={handleChangeLocation}
              disabled={!!basicEventObject?.contextId || isDisabled}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomInput
              id="lng"
              label={'Longitude'}
              value={basicEventObject?.location?.lng}
              inputAndMessageContainer={StyledEventInputContainer}
              placeholder="Enter Longitude..."
              type="number"
              onChange={handleChangeLocation}
              disabled={!!basicEventObject?.contextId || isDisabled}
              required
            />
          </Grid>
        </Grid>
      )}
    </div>
  )
}
